/* eslint-disable no-case-declarations */

/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_CANVAS_CONTENT_INFO',
  PUT: 'UPDATE_CANVAS_CONTENT_INFO',
  DELETE: 'DELETE_CANVAS_CONTENT_INFO',
  RESET: 'RESET_CANVAS_CONTENT_INFO',
};


export const canvasContentInfoReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [
        ...state,
        ...action.payload,
      ];
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const values = [ ...state ];
      let removedIndexes=[];
      for(let i in action.payload){
        let ind=values.findIndex((item)=>item.UID==action.payload[i].UID);
        if(ind>-1){
          removedIndexes.push(ind);
        }
      }
      removedIndexes.sort((a, b) => b - a);
      for (let i = 0; i < removedIndexes.length; i++) {
        values.splice(removedIndexes[i], 1);
      }
      return values;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
